<div [formGroup]="form()">
  <div
    class="form-group form-floating locations-select"
    [class.invalid]="form().hasError('salaryRange') && submitAttempt()"
  >
    <ng-select
      class="form-control"
      formControlName="preferredLocations"
      [items]="cityItems()"
      [multiple]="true"
      [loading]="citiesLoading()"
      [typeahead]="cityInput$"
      [minTermLength]="2"
      [typeToSearchText]="'jobboard.platform.profile.sections.preferences.city-search-text' | transloco"
      [notFoundText]="'ct-library.constants.ng-select.placeholders.not-found' | transloco"
      [hideSelected]="true"
      [placeholder]="'jobboard.platform.profile.sections.preferences.locations-placeholder' | transloco"
      id="profileLocations"
    >
      <ng-template ng-label-tmp let-item="item" let-clear="clear">
        <ct-lib-tag [deletable]="true" (onDelete)="clear(item)">{{ item }}</ct-lib-tag>
      </ng-template>
    </ng-select>
    <label for="profileLocations">{{
      'jobboard.platform.profile.sections.preferences.locations' | transloco
    }}</label>
  </div>
  <div class="row">
    <div class="col-12 col-md-6 form-group form-floating">
      <ng-select
        class="form-control"
        formControlName="workingModel"
        [clearable]="true"
        [placeholder]="'ct-library.constants.ng-select.placeholders.placeholder' | transloco"
        id="profileWorkingModel"
      >
        @for (model of workingModels; track model) {
          <ng-option [value]="model">{{ workingModelKey(model) | transloco }}</ng-option>
        }
      </ng-select>
      <label for="profileWorkingModel">{{
        'jobboard.platform.profile.sections.preferences.working-model' | transloco
      }}</label>
    </div>
    <div class="col-12 col-md-6 form-group form-floating">
      <ng-select
        class="form-control"
        formControlName="availability"
        [clearable]="true"
        [placeholder]="'ct-library.constants.ng-select.placeholders.placeholder' | transloco"
        id="profileAvailability"
      >
        @for (option of availabilityOptions; track option) {
          <ng-option [value]="option">{{ availabilityKey(option) | transloco }}</ng-option>
        }
      </ng-select>
      <label for="profileAvailability">{{
        'jobboard.platform.profile.sections.preferences.availability' | transloco
      }}</label>
    </div>
  </div>
  <div class="row">
    <div class="col-6 col-md-3 form-group form-floating companion-form">
      <ct-lib-salary-input
        [control]="salaryMinControl()"
        [currencyCode]="form().controls['currency'].value"
        [displayCurrencySymbol]="false"
        [placeholder]="'jobboard.platform.profile.sections.preferences.salary-min' | transloco"
      ></ct-lib-salary-input>
    </div>
    <div class="col-6 col-md-3 form-group form-floating companion-form">
      <ct-lib-salary-input
        [control]="salaryMaxControl()"
        [currencyCode]="form().controls['currency'].value"
        [displayCurrencySymbol]="false"
        [placeholder]="'jobboard.platform.profile.sections.preferences.salary-max' | transloco"
      ></ct-lib-salary-input>
    </div>
    <div class="col-6 col-md-2 form-group form-floating companion-form">
      <ng-select
        class="form-control"
        formControlName="currency"
        [clearable]="false"
        [placeholder]="'ct-library.constants.ng-select.placeholders.placeholder' | transloco"
        id="profileCurrency"
      >
        @for (currencyCode of currencies; track currencyCode) {
          <ng-option [value]="currencyCode">{{ currencyCode }}</ng-option>
        }
      </ng-select>
      <label for="profileCurrency">{{
        'jobboard.platform.profile.sections.preferences.currency' | transloco
      }}</label>
    </div>
    <div class="col-6 col-md-4 salary-interval">
      <p class="text-muted">{{
        'jobboard.platform.profile.sections.preferences.salary-interval' | transloco
      }}</p>
    </div>
  </div>
  @if (form().hasError('salaryRange') && submitAttempt()) {
    <p class="validation-text">{{
      'jobboard.platform.profile.sections.preferences.salary-range-invalid' | transloco
    }}</p>
  }
</div>
